import { render, staticRenderFns } from "./GalleryModule.vue?vue&type=template&id=1aa1713d&scoped=true&"
import script from "./GalleryModule.vue?vue&type=script&lang=js&"
export * from "./GalleryModule.vue?vue&type=script&lang=js&"
import style0 from "./GalleryModule.vue?vue&type=style&index=0&id=1aa1713d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa1713d",
  null
  
)

export default component.exports